import Vue from 'vue';
import Toasted from 'vue-toasted';

Vue.use(Toasted);


// error module
Vue.toasted.register(
  'error',
  (payload) => {
    if (!payload.message) {
      return 'Something Wrong';
    }
    return `${payload.message}`;
  },
  {
    theme: 'bubble',
    icon: 'warning',
    position: 'bottom-right',
    action: {
      text: 'CLOSE',
      onClick: (e, toastObject) => {
        toastObject.goAway(0);
      },
    },
    duration: 3000,
  },
);


// success module
Vue.toasted.register(
  'success',
  (payload) => {
    if (!payload.message) {
      return 'Success!';
    }
    return `${payload.message}`;
  },
  {
    theme: 'outline',
    icon: 'check_circle_outline',
    position: 'bottom-right',
    action: {
      text: 'CLOSE',
      onClick: (e, toastObject) => {
        toastObject.goAway(0);
      },
    },
    duration: 3000,
  },
);

export default Toasted;
